import React from "react";
import Im from "immutable";

export function FormNonFieldErrors({ errors }) {
  const attr = "non_field_errors";
  if (errors && errors.has(attr)) {
    // console.log("NON_FIELD_ERRORS", errors)
    let _errors = errors.get(attr);
    if (Im.List.isList(_errors)) {
      _errors = (
        <ul style={{ marginLeft: "-1em" }}>
          {_errors.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );
    }
    return <div className="alert alert-danger form-control-sm">{_errors}</div>;
  }
  return "";
}
